import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import location from './location'
import locationSearch from './locationSearch'
import home from './home'
import order from './order'
import personalize from './personalize'
import ticket from './ticket'
import favorite from './favorite'
import friends from './friends'
import forgotPassword from './forgotPassword'
import orderDetail from './orderDetail'
import checkout from './checkout'
import pastorder from './pastorder'
import orderHistory from './orderHistory'
import profile from './profile'
import creditHistory from './creditHistory'
import preferences from './preferences'
import cart from './cart'
import delivery from './delivery'
import user, { LOGOUT } from './user'
import join from './join'
import { contactUsReducerPlugin } from './formPlugins'
import unsubscribe from './unsubscribe'
import token from './token'
import comingSoon from './comingSoon'
import checkHealth from './checkHealth'
import credits from './credits'
import featureToggles from './featureToggles'

const appReducer = combineReducers({
  home,
  order,
  ticket,
  location,
  locationSearch,
  forgotPassword,
  personalize,
  checkout,
  pastorder,
  featureToggles,
  favorite,
  friends,
  orderHistory,
  orderDetail,
  creditHistory,
  profile,
  preferences,
  cart,
  delivery,
  user,
  join,
  token,
  comingSoon,
  checkHealth,
  unsubscribe,
  credits,
  form: formReducer.plugin({
    contactUs: contactUsReducerPlugin
  })
})

const rootReducer = (state, action) => {
  // blow away state on logout
  if (action.type === LOGOUT) {
    state = {}
  }

  return appReducer(state, action)
}

export default rootReducer
